import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DueDateBeforeIssueDateError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.due-date.due-date-before-issue-date');
    }
}
